/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { PersonaTypeEnum } from '../models/PersonaTypeEnum';
import type { PlayerRatingExplanation } from '../models/PlayerRatingExplanation';
import type { PlayerRatingMatch } from '../models/PlayerRatingMatch';
import type { PlayerRatingRanking } from '../models/PlayerRatingRanking';
import type { PlayerRatingRankingList } from '../models/PlayerRatingRankingList';
import type { PlayerRatingRankingType } from '../models/PlayerRatingRankingType';
import type { PlayerRatingV2 } from '../models/PlayerRatingV2';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PlayerRatingService {
    /**
     * Get Player Rating Match
     * @param playerId
     * @param matchId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingMatchPlayerRatingMatchMatchIdPlayerPlayerIdGet(
        playerId: number,
        matchId: number,
    ): CancelablePromise<(number | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/match/{match_id}/player/{player_id}',
            path: {
                'player_id': playerId,
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Rating Match
     * @param matchId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRatingMatchPlayerRatingMatchMatchIdGet(
        matchId: number,
    ): CancelablePromise<Record<string, (number | null)>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating With Matches
     * @param playerId
     * @param limit
     * @param offset
     * @param leagueId
     * @returns PlayerRatingMatch Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingWithMatchesPlayerRatingPlayerPlayerIdGet(
        playerId: number,
        limit: number = 100,
        offset?: number,
        leagueId?: (number | null),
    ): CancelablePromise<Array<PlayerRatingMatch>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/player/{player_id}',
            path: {
                'player_id': playerId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating Ranking
     * @param playerId
     * @returns PlayerRatingRanking Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingRankingPlayerRatingRankingPlayerPlayerIdGet(
        playerId: number,
    ): CancelablePromise<PlayerRatingRanking> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/ranking/player/{player_id}',
            path: {
                'player_id': playerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating Explanation
     * @param matchId
     * @returns PlayerRatingExplanation Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingExplanationPlayerRatingExplanationMatchMatchIdGet(
        matchId: number,
    ): CancelablePromise<PlayerRatingExplanation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/explanation/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating Ranking
     * @param playerId
     * @param rankingType
     * @param halfLimit
     * @param offset
     * @returns PlayerRatingRankingList Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingRankingPlayerRatingListRankingTypePlayerPlayerIdGet(
        playerId: number,
        rankingType: PlayerRatingRankingType,
        halfLimit: number,
        offset?: (number | null),
    ): CancelablePromise<PlayerRatingRankingList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/list/{ranking_type}/player/{player_id}',
            path: {
                'player_id': playerId,
                'ranking_type': rankingType,
            },
            query: {
                'half_limit': halfLimit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating Ranking Count
     * @param playerId
     * @param rankingType
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingRankingCountPlayerRatingCountRankingTypePlayerPlayerIdGet(
        playerId: number,
        rankingType: PlayerRatingRankingType,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/count/{ranking_type}/player/{player_id}',
            path: {
                'player_id': playerId,
                'ranking_type': rankingType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating Ranking History
     * @param playerId
     * @param rankingType
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingRankingHistoryPlayerRatingRankingHistoryPlayerPlayerIdGet(
        playerId: number,
        rankingType: PlayerRatingRankingType,
    ): CancelablePromise<Record<string, (number | null)>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/ranking/history/player/{player_id}',
            path: {
                'player_id': playerId,
            },
            query: {
                'ranking_type': rankingType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Has League Player Rating
     * @param leagueId
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static hasLeaguePlayerRatingPlayerRatingHasLeaguePlayerRatingLeagueIdGet(
        leagueId: number,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/has_league_player_rating/{league_id}',
            path: {
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating Match V2
     * @param matchId
     * @param personaType
     * @returns any Successful Response
     * @throws ApiError
     */
    public static playerRatingMatchV2(
        matchId: number,
        personaType: PersonaTypeEnum = PersonaTypeEnum.BASE,
    ): CancelablePromise<Record<string, (number | null)>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/v2/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            query: {
                'persona_type': personaType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Rating Match V3
     * @param matchId
     * @param personaType
     * @returns PlayerRatingV2 Successful Response
     * @throws ApiError
     */
    public static playerRatingMatchV3(
        matchId: number,
        personaType: PersonaTypeEnum = PersonaTypeEnum.BASE,
    ): CancelablePromise<Array<PlayerRatingV2>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/player_rating/v3/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            query: {
                'persona_type': personaType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
